import { render, staticRenderFns } from "./DependencyObjectDlg.vue?vue&type=template&id=dba9d6dc&scoped=true"
import script from "./DependencyObjectDlg.vue?vue&type=script&lang=js"
export * from "./DependencyObjectDlg.vue?vue&type=script&lang=js"
import style0 from "./DependencyObjectDlg.vue?vue&type=style&index=0&id=dba9d6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba9d6dc",
  null
  
)

export default component.exports